import React, { useState } from 'react'; // 1. useState ఇంపోర్ట్ చేసాము
import { NavLink, useNavigate } from 'react-router-dom';
import './Sidebar.css';
import logo from '../assets/Crlogo.webp';

const Sidebar = () => {
    const navigate = useNavigate();
    const userName = localStorage.getItem('userName') || 'Admin';

    // 2. Masters డ్రాప్‌డౌన్ కంట్రోల్ చేయడానికి స్టేట్
    const [isMastersOpen, setIsMastersOpen] = useState(false);

    const menuItems = [
        { name: 'Dashboard', icon: '🏠', path: '/dashboard' },
        { name: 'Lab Tests', icon: '🔬', path: '/lab-tests' },
        { name: 'Packages', icon: '📦', path: '/packages' },
        { name: 'Organ Information', icon: '🫀', path: '/organ-info' },
        { name: 'Customer List', icon: '👥', path: '/customers' },
        { name: 'Employees', icon: '👨‍💼', path: '/employees' },
        { name: 'Orders', icon: '🛒', path: '/orders' },
        { name: 'Blogs', icon: '✍️', path: '/blogs' },
        { name: 'Equipment', icon: '🛠️', path: '/equipment' },
        { name: 'News', icon: '📰', path: '/news' },
        { name: 'Booking Reports', icon: '📊', path: '/booking-reports' },
    ];

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = '/login';
    };

    return (
        <div className="sidebar">
            <div className="sidebar-brand">
                <img src={logo} alt="Credence Logo" className="brand-logo" />
            </div>

            <div className="sidebar-menu">
                {/* Regular Menu Items */}
                {menuItems.map((item) => (
                    <NavLink
                        key={item.name}
                        to={item.path}
                        className={({ isActive }) => isActive ? 'menu-item active' : 'menu-item'}
                    >
                        <span className="menu-icon">{item.icon}</span>
                        <span className="menu-text">{item.name}</span>
                    </NavLink>
                ))}

                {/* 3. Masters Dropdown Section */}
                <div className="dropdown-section">
                    <div
                        className={`menu-item ${isMastersOpen ? 'active' : ''}`}
                        onClick={() => setIsMastersOpen(!isMastersOpen)}
                        style={{ cursor: 'pointer' }}
                    >
                        <span className="menu-icon">⚙️</span>
                        <span className="menu-text">Masters</span>
                        <span style={{ marginLeft: 'auto', fontSize: '12px' }}>
                            {isMastersOpen ? '▲' : '▼'}
                        </span>
                    </div>

                    {/* 4. Masters కింద వచ్చే Dropdown Items */}
                    {isMastersOpen && (
                        <div className="sub-menu" style={{ paddingLeft: '20px', background: 'rgba(0,0,0,0.05)' }}>
                            <NavLink
                                to="/department-master"
                                className={({ isActive }) => isActive ? 'menu-item active' : 'menu-item'}
                                style={{ fontSize: '14px' }}
                            >
                                <span className="menu-icon">🏢</span>
                                <span className="menu-text">Departments</span>
                            </NavLink>

                            <NavLink
                                to="/banner-master"
                                className={({ isActive }) => isActive ? 'menu-item active' : 'menu-item'}
                                style={{ fontSize: '14px' }}
                            >
                                <span className="menu-icon">🖼️</span>
                                <span className="menu-text">Banners</span>
                            </NavLink>

                            {/* భవిష్యత్తులో మరిన్ని మాస్టర్స్ ఇక్కడ యాడ్ చేసుకోవచ్చు */}
                        </div>
                    )}
                </div>
            </div>

            <div className="sidebar-footer">
                <div className="footer-item">
                    <span className="menu-icon">⚙️</span>
                    <span>Settings</span>
                </div>
                <div className="footer-item logout" onClick={handleLogout}>
                    <span className="menu-icon">🚪</span>
                    <span>Sign Out</span>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;